import React from "react";

const Blogs = () => {
  return (
    <div className="py-6 px-[8%]">
      <div className="p-6 py-12  bg-slate-900 text-gray-50">
        <div className="container mx-auto">
          <div className="flex flex-col text-center lg:flex-row items-center justify-between">
            <h2 className="text-center text-6xl tracking-tighter font-bold">
              Coming soon...
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
